import React, { useState, useEffect } from 'react'
import { Row, Col, ControlLabel, SelectPicker, Checkbox, RadioGroup, Radio, Cascader } from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled, isRequired } from '../../utils/ValidatorUtils'
import InputForm from '../../components/forms/input/InputForm'
import classNames from 'classnames'
import { locationZipcode } from '../../components/location/Location'

export default function CreatePayeeAndTaxInfoForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  rowData,
  isAddBankAccount,
  ...props
}) {
  const [formSchema, setFormSchema] = useState(schema)
  const [checkRadio, setCheckRadio] = useState('0')
  //const [checkSelect, setCheckSelect] = useState()
  const [location, setLocation] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [roles, setRoles] = useState()
  console.log('formSchema===>', formSchema)

  useEffect(() => {
    if (rowData && !isAddBankAccount) {
      setCheckRadio(rowData.registerType || '0')
      //setCheckSelect(rowData.actingRole)
      setRoles(rowData.actingRole)
      // console.log('rowData==>', rowData)
      clearErrors()
    }
  }, [rowData])

  useEffect(() => {
    handleLocation()
  }, [])

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await locationZipcode()
    setLocation(location)
    setIsLoading(false)
  }

  return (
    <>
      <Row>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.regiterType.validators, formSchema.regiterType.label)}
          </ControlLabel>
        </Col>
        <Col lg={18} md={18} sm={24} xs={24}>
          <ErrorMessage error={errors[formSchema.regiterType.name]} />
          <Controller
            name={formSchema.regiterType.name}
            control={control}
            defaultValue={rowData?.registerType || '0'}
            rules={isValidators(formSchema.regiterType.validators)}
            render={(props) => {
              return (
                <RadioGroup
                  inline
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                    setCheckRadio(value)
                    clearErrors()
                  }}
                >
                  {formSchema.regiterType.options.map((item) => (
                    <>
                      {item.value != '9' && (
                        <Radio key={item.value} value={item.value}>
                          <p style={{ marginTop: -3 }}>{item.label}</p>
                        </Radio>
                      )}
                    </>
                  ))}
                </RadioGroup>
              )
            }}
          />
        </Col>
      </Row>

      {checkRadio == '0' && (
        <>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.idCard.validators, formSchema.idCard.label)}
            </Col>
            <Col lg={19} md={19} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.idCard}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.taxId}
                isInputNumber={true}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.titleName.validators, formSchema.titleName.label)}
            </Col>
            <Col lg={4} md={4} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.titleName}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.title}
              />
            </Col>
            <Col lg={1} md={1} sm={24} xs={24} style={{ textAlign: 'left', marginTop: 10 }}>
              {requiredFiled(formSchema.nameLastName.validators, formSchema.nameLastName.label)}
            </Col>
            <Col lg={6} md={6} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.nameLastName}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.name}
              />
            </Col>
            <Col lg={2} md={2} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.lastName.validators, formSchema.lastName.label)}
            </Col>
            <Col lg={6} md={6} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.lastName}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.lastName}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.roles.validators, formSchema.roles.label)}
            </Col>
            <Col lg={19} md={19} sm={24} xs={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[formSchema.roles.name]} />
              <Controller
                name={formSchema.roles.name}
                control={control}
                // defaultValue={checkSelect || null}
                defaultValue={rowData?.actingRole || null}
                rules={isValidators(formSchema.roles.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      searchable={true}
                      data={formSchema.roles.options}
                      value={props.value}
                      block
                      placeholder={'เลือก' + formSchema.roles.label}
                      onChange={(value) => {
                        props.onChange(value)
                        //setCheckSelect(value)
                        setRoles(value)
                      }}
                      checked={props.value}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}></Col>
          </Row>
          {roles == 7 && formSchema?.subProjectCode && (
            <Row>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
                {requiredFiled(
                  formSchema.subProjectCode.validators,
                  formSchema.subProjectCode.label
                )}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
                <InputForm
                  schema={formSchema.subProjectCode}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  hideLabel
                  style={{ marginTop: -5 }}
                  value={rowData?.subProjectCode}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.phoneNumber.validators, formSchema.phoneNumber.label)}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.phoneNumber}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.phoneNumber}
                isInputNumber={true}
              />
            </Col>
            <Col lg={3} md={3} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.email.validators, formSchema.email.label)}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.email}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.email}
              />
            </Col>
          </Row>
          {/* <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.email.validators, formSchema.email.label)}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.email}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.email}
              />
            </Col>
          </Row> */}
        </>
      )}

      {(checkRadio == '1' || checkRadio == '2') && (
        <>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.orgId.validators, formSchema.orgId.label)}
            </Col>
            <Col lg={19} md={19} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.orgId}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.taxId}
                isInputNumber={true}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.orgName.validators, formSchema.orgName.label)}
            </Col>
            <Col lg={19} md={19} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.orgName}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.name}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.branchCode.validators, formSchema.branchCode.label)}
            </Col>
            <Col lg={19} md={19} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.branchCode}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.branchCode}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.phoneNumber.validators, formSchema.phoneNumber.label)}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.phoneNumber}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.phoneNumber}
                isInputNumber={true}
              />
            </Col>
            <Col lg={3} md={3} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.email.validators, formSchema.email.label)}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.email}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.email}
              />
            </Col>
          </Row>
          {/* <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.email.validators, formSchema.email.label)}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.email}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.email}
              />
            </Col>
          </Row> */}
        </>
      )}

      {checkRadio == '9' && (
        <>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.otherNumber.validators, formSchema.otherNumber.label)}
            </Col>
            <Col lg={19} md={19} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.otherNumber}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.taxId}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              {requiredFiled(formSchema.otherName.validators, formSchema.otherName.label)}
            </Col>
            <Col lg={19} md={19} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.otherName}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.name}
              />
            </Col>
          </Row>
        </>
      )}

      {checkRadio == '9' ? (
        <Row>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
            {requiredFiled(formSchema.description.validators, formSchema.description.label)}
          </Col>
          <Col lg={19} md={19} sm={24} xs={24} style={{ marginTop: 10 }}>
            <InputForm
              schema={formSchema.description}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              rows={4}
              componentClass="textarea"
              hideLabel
              style={{ marginTop: -5 }}
              value={rowData?.address}
            />
          </Col>
        </Row>
      ) : (
        <>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.buildingName.validators) && 'required')}
              >
                {formSchema.buildingName.label}
              </ControlLabel>
              <ErrorMessage error={errors.buildingName} />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.buildingName}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.buildingName}
              />
            </Col>
            <Col lg={3} md={3} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.roomNumber.validators) && 'required')}
              >
                {formSchema.roomNumber.label}
              </ControlLabel>
              <ErrorMessage error={errors.roomNumber} />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.roomNumber}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.roomNumber}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.houseNumber.validators) && 'required')}
              >
                {formSchema.houseNumber.label}
              </ControlLabel>
              <ErrorMessage error={errors.houseNumber} />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.houseNumber}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.numberOfAddress}
              />
            </Col>
            <Col lg={3} md={3} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              <ControlLabel
                className={classNames(
                  isRequired(formSchema.villageNumber.validators) && 'required'
                )}
              >
                {formSchema.villageNumber.label}
              </ControlLabel>
              <ErrorMessage error={errors.villageNumber} />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.villageNumber}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.moo}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.lane.validators) && 'required')}
              >
                {formSchema.lane.label}
              </ControlLabel>
              <ErrorMessage error={errors.lane} />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.lane}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.box}
              />
            </Col>
            <Col lg={3} md={3} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.villageName.validators) && 'required')}
              >
                {formSchema.villageName.label}
              </ControlLabel>
              <ErrorMessage error={errors.villageName} />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.villageName}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.villageName}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.road.validators) && 'required')}
              >
                {formSchema.road.label}
              </ControlLabel>
              <ErrorMessage error={errors.road} />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10 }}>
              <InputForm
                schema={formSchema.road}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel
                style={{ marginTop: -5 }}
                value={rowData?.roadName}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={10} md={10} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
              <ControlLabel
                className={classNames(isRequired(formSchema.location.validators) && 'required')}
              >
                {formSchema.location.label}
              </ControlLabel>
              <ErrorMessage error={errors.location} />
            </Col>
            <Col lg={13} md={13} sm={24} xs={24} style={{ marginTop: 10 }}>
              <Controller
                name={formSchema.location.name}
                control={control}
                defaultValue={rowData?.location}
                rules={isValidators(formSchema.location.validators)}
                render={(props) => {
                  return (
                    <Cascader
                      size="lg"
                      block
                      menuWidth={180}
                      data={location}
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                      placeholder={formSchema.location.label}
                      // disabled={isSameAddress}
                    ></Cascader>
                  )
                }}
              />
            </Col>
          </Row>
        </>
      )}

      <Row>
        <Col lg={4} md={4} sm={24} xs={24} style={{ marginTop: 10 }}></Col>
        <Col lg={10} md={10} sm={24} xs={24} style={{ marginTop: 10 }}>
          {checkRadio != '2' && (
            <>
              <ErrorMessage error={errors[formSchema.expenseForTax.name]} />
              <Controller
                key={schema?.expenseForTax?.name}
                name={schema?.expenseForTax?.name}
                control={control}
                defaultValue={rowData?.isWithholding || false}
                render={(props) => {
                  return (
                    <Checkbox
                      onChange={(value, checked) => {
                        // console.log('checkExpenseForTax', checked)
                        props.onChange(checked)
                      }}
                      checked={props.value}
                    >
                      <p style={{ marginTop: -6 }}>{schema?.expenseForTax?.label}</p>
                    </Checkbox>
                  )
                }}
              />
            </>
          )}
        </Col>
      </Row>

      <Row>
        <Col lg={4} md={4} sm={24} xs={24}></Col>
        <Col lg={10} md={10} sm={24} xs={24}>
          <ErrorMessage error={errors[formSchema.vatRegistration.name]} />
          <Controller
            key={schema?.vatRegistration?.name}
            name={schema?.vatRegistration?.name}
            control={control}
            defaultValue={rowData?.isVatRegister || false}
            render={(props) => {
              return (
                <Checkbox
                  onChange={(value, checked) => {
                    console.log('checkVatRegistration', checked)
                    props.onChange(checked)
                  }}
                  checked={props.value}
                >
                  <p style={{ marginTop: -6 }}>{schema?.vatRegistration?.label}</p>
                </Checkbox>
              )
            }}
          />
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}></Col>
      </Row>
    </>
  )
}
